module.exports = __webpack_public_path__ + "img/history_icon.a70a5c04.svg";